import { ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ProfileData } from '../hooks/useProfileData';

interface PublicProfileSocialLinksProps {
  links: ProfileData['socialMedia'];
  className?: string;
  linkClassName?: string;
}

const labels: Array<[keyof ProfileData['socialMedia'], string]> = [
  ['linkedin', 'LinkedIn'],
  ['facebook', 'Facebook'],
  ['instagram', 'Instagram'],
  ['tiktok', 'TikTok'],
  ['website', 'Website']
];

export function PublicProfileSocialLinks({
  links,
  className,
  linkClassName
}: PublicProfileSocialLinksProps) {
  const visibleLinks = labels.filter(([network]) => Boolean(links[network]));
  if (visibleLinks.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Professional links" className={cn('flex flex-wrap gap-2', className)}>
      {visibleLinks.map(([network, label]) => (
        <a
          key={network}
          href={links[network]}
          target="_blank"
          rel="noopener noreferrer"
          className={cn(
            'inline-flex min-h-11 items-center gap-1.5 rounded-full border px-4 text-sm font-medium transition',
            linkClassName
          )}
        >
          {label}<ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
        </a>
      ))}
    </nav>
  );
}
